import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {App as AntdApp} from "antd";
import {Loading} from "~/components";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import {useConnectGscMutation} from "~/reduxs/api/gscApiSlice";

// Khoá chống-gọi-lặp cấp MODULE (không phải useRef): sống sót qua remount của component
// trong cùng một lần tải trang. authorization code chỉ dùng được 1 lần — nếu component bị
// mount 2 lần, lần 2 sẽ thấy state đã xử lý và bỏ qua, tránh đốt code + invalid_grant.
let handledState = null;

/**
 * Đích redirect của Google OAuth (`/gsc/oauth/callback`) — phải khớp GOOGLE_OAUTH_REDIRECT.
 *
 * Google chuyển trình duyệt về đây kèm ?code=&state=. Ta đối chiếu state với sessionStorage
 * (chống CSRF nhẹ), lấy projectId từ state (phần trước dấu '.'), POST code về BE để đổi token,
 * rồi điều hướng vào trang GSC của dự án (BE lúc này trả status=property_pending → chọn property).
 */
function GscCallback() {

	const navigate = useNavigate();
	const {notification} = AntdApp.useApp();
	const [connectGsc] = useConnectGscMutation();
	const [error, setError] = useState('');

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const code = params.get('code');
		const state = params.get('state') || '';
		const oauthError = params.get('error');

		const home = process.env.REACT_APP_HOMEPAGE || '';

		// Xoá ngay ?code&state khỏi thanh địa chỉ để một lần F5 không gửi lại code cũ
		// (authorization code chỉ dùng được MỘT lần → gửi lại sẽ dính invalid_grant).
		window.history.replaceState({}, '', window.location.pathname);

		if (oauthError) {
			setError('Bạn đã huỷ hoặc từ chối cấp quyền cho Google.');
			return;
		}

		const savedState = sessionStorage.getItem('gsc_oauth_state');
		sessionStorage.removeItem('gsc_oauth_state');

		if (!code || !state || (savedState && savedState !== state)) {
			setError('Phiên kết nối không hợp lệ. Vui lòng thử lại.');
			return;
		}

		const projectId = state.split('.')[0];

		if (!projectId) {
			setError('Không xác định được dự án. Vui lòng thử lại.');
			return;
		}

		// Chỉ đổi code MỘT lần cho mỗi state, kể cả khi component bị mount lại.
		if (handledState === state) return;
		handledState = state;

		(async () => {
			try {
				await connectGsc({projectId, code}).unwrap();
				notification.success({message: 'Đã kết nối', description: 'Kết nối Google thành công. Hãy chọn property.'});
				navigate(`${home}/projects/${projectId}/gsc`, {replace: true});
			} catch (e) {
				setError(rtkErrorMessage(e, 'Không hoàn tất được kết nối Google'));
			}
		})();
	}, [connectGsc, navigate, notification]);

	if (error) {
		return (
			<div className="container" style={{padding: 40, textAlign: 'center'}}>
				<p style={{color: '#dc2626', marginBottom: 16}}>{error}</p>
				<a href={`${process.env.REACT_APP_HOMEPAGE || ''}/projects`}>← Về danh sách dự án</a>
			</div>
		);
	}

	return (
		<div style={{padding: 60, textAlign: 'center'}}>
			<Loading />
			<p style={{marginTop: 16, color: '#6b7280'}}>Đang hoàn tất kết nối Google…</p>
		</div>
	);
}

export default GscCallback;
